import React from "react";
import { PartInfo } from "../../hooks/useAllParts";

export const PartsList: React.FC<{ parts: PartInfo[] }> = ({ parts }) => {
  if (parts.length === 0) return null;

  return (
    <ul className="list-disc list-inside space-y-1 mb-4">
      {parts.map((part, index) => (
        <li key={index} className="text-sm">
          ({part.partName || "N/A"} - {part.partNumber || "N/A"} - {part.store || "N/A"})
        </li>
      ))}
    </ul>
  );
};
